module.exports = __webpack_public_path__ + "media/images/profile/ideal-partner-info-235acbb1743f530d13dac9587d484872.svg";